import { render } from "./denied.vue?vue&type=template&id=57201096"
import script from "./denied.vue?vue&type=script&lang=js"
export * from "./denied.vue?vue&type=script&lang=js"

import "./denied.vue?vue&type=style&index=0&id=57201096&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__